import React from "react";

import { Box, DialogContent } from "@mui/material";

import useFirebase from "../../../../../config/context/firebaseContext";
import useMainState from "../../../../../config/context/mainStateContext";
import useModal from "../../../../../config/context/modalContext";
import storageKey from "../../../../../config/storageKey";
import { Dev } from "../../../../../config/util/consoleUtil";

import MainBorderButton from "../../../../../components/MainBorderButton";
import { WideDialog } from "../../../../../components/MainModalSimple/styles";
import MainSolidButton from "../../../../../components/MainSolidButton";
import MainText from "../../../../../components/MainText";
import { ModalTransition } from "../../../../../components/ModalTransition";

export default function NewVersionBanner() {
  const { forceRefreshConfigs, getConfig } = useFirebase();
  const { pushAlert } = useModal();
  const { openLink } = useMainState();

  const lastDimiss =
    parseInt(window?.localStorage.getItem(storageKey.LAST_UPDATE_DIMISS) || "0") || 0;

  const nowTime = new Date().getTime();

  const versionIsLowerThan = (v1: string, v2: string) => {
    const v1Map = v1.split(".");
    const v2Map = v2.split(".");
    return v1Map.some((v, i) => parseInt(v) < parseInt(v2Map[i] || "0"));
  };

  const [renderModal, setRenderModal] = React.useState(
    nowTime > lastDimiss + 259200000 &&
      versionIsLowerThan(
        String(process.env.REACT_APP_CURRENT_VERSION || "0"),
        String(getConfig("cordova" in window ? "latest_mobile_version" : "latest_web_version"))
      )
  );

  const [open, setOpen] = React.useState(true);

  const [loading, setLoading] = React.useState(false);

  const ScrollBoxRef = React.useRef(null);

  const handleClose = () => {
    window?.localStorage.setItem(storageKey.LAST_UPDATE_DIMISS, String(nowTime));
    setOpen(false);
    setTimeout(() => {
      setRenderModal(false);
    }, 200);
  };

  const forceUpdate = async () => {
    try {
      setLoading(true);
      await forceRefreshConfigs();

      if ("cordova" in window) {
        openLink("https://play.google.com/store/apps/details?id=com.circular.ufrn");
      } else {
        navigator?.serviceWorker?.getRegistration().then(function (reg) {
          if (reg) {
            reg.unregister().then(function () {
              window.location.reload();
            });
          } else {
            window.location.reload();
          }
        });
      }
    } catch (error) {
      console.log(...new Dev("forceUpdate", error).Error());
      pushAlert({ message: "Erro ao atualizar", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {}, []);

  return (
    <>
      {renderModal && (
        <WideDialog
          fullWidth={true}
          open={open}
          onClose={handleClose}
          TransitionComponent={ModalTransition}
        >
          <DialogContent sx={{ overflowY: "scroll" }} ref={ScrollBoxRef}>
            <Box mb={2}>
              <MainText size="subtitle">Nova Versão Disponível</MainText>
            </Box>

            <Box mb={1}>
              <MainText color="regular">Uma nova versão do aplicativo está disponível.</MainText>
            </Box>

            <MainText color="regular">Deseja atualizar agora?</MainText>

            <Box display={"flex"} justifyContent={"center"} alignItems={"center"} gap={1} mt={2}>
              <MainBorderButton text="Cancelar" onClick={() => handleClose()} />
              <MainSolidButton text="Atualizar" onClick={forceUpdate} loading={loading} />
            </Box>
          </DialogContent>
        </WideDialog>
      )}
    </>
  );
}
